import { _ as _class_call_check } from "@swc/helpers/_/_class_call_check";
import { LocalizationStore } from "./localization/LocalizationStore";
var NEGATIVE_SYMBOLS = [
    "\u2212",
    "-"
];
// https://observablehq.com/@mbostock/localized-number-parsing
export var NumberParser = function NumberParser() {
    "use strict";
    var _this = this;
    _class_call_check(this, NumberParser);
    this.parse = function(value) {
        var trimmedValue = value.trim();
        var isNegative = NEGATIVE_SYMBOLS.includes("".concat(trimmedValue[0]));
        var positiveTrimmedValue = isNegative ? trimmedValue.slice(1) : trimmedValue;
        var parsedValue = positiveTrimmedValue.replace(_this._group, "").replace(_this._decimal, ".").replace(_this._numeral, _this._index);
        if (!parsedValue) {
            return NaN;
        }
        if (isNegative) {
            return -parsedValue;
        }
        return +parsedValue;
    };
    var parts = LocalizationStore.get().intlForCurrency.formatNumberToParts(12345.6);
    var numerals = LocalizationStore.get().intlForCurrency.formatNumber(9876543210, {
        useGrouping: false
    }).split("").reverse();
    var index = new Map(numerals.map(function(d, i) {
        return [
            d,
            i
        ];
    }));
    this.separator = parts.find(function(d) {
        return d.type === "group";
    }).value;
    this._group = new RegExp("[".concat(this.separator, "]"), "g");
    this.decimal = parts.find(function(d) {
        return d.type === "decimal";
    }).value;
    this._decimal = new RegExp("[".concat(this.decimal, "]"));
    this._numeral = new RegExp("[".concat(numerals.join(""), "]"), "g");
    this._index = function(d) {
        return index.get(d).toString();
    };
};
